import { render, staticRenderFns } from "./HistoryMenuView.vue?vue&type=template&id=1d3b2795"
import script from "./HistoryMenuView.vue?vue&type=script&lang=js"
export * from "./HistoryMenuView.vue?vue&type=script&lang=js"
import style0 from "./HistoryMenuView.vue?vue&type=style&index=0&id=1d3b2795&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports